import React, { useState } from 'react';
import styles from './SideBar.module.css';
import { Navbar } from 'react-bootstrap';
import { NavBar as FloNavBar } from './NavBar';
import classnames from 'classnames';
import { User } from 'model';
import { useHistory } from 'react-router-dom';

export type SideBarProps = {
  onLogout: (history: any) => void,
  user?: User
}

export const SideBar = (props: SideBarProps) => {
  const [isExpanded, setExpanded] = useState(false);
  const history = useHistory();

  return (
    <>
      { /* Mobile  */ }
      <div className={classnames(styles.root, styles.mobileHidden)}>
        <Navbar className={styles.navbar} expand="xl" expanded={isExpanded} onToggle={(expanded: boolean) => { setExpanded(expanded) }}>
          <div className={styles.logoWrapperMobile}>
            <a href='/'>
              <img
                alt="Flo Multi-Unit Dashboard"
                src="/images/MoenSmartLogo.png"
              />
            </a>
          </div>
          <Navbar.Brand href="#home"></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" >
            <FloNavBar
              onLogout    = {() => props.onLogout(history)}
              user        = {props.user}
              onItemClick = {() => { setExpanded(false) }}
              isMobile
            />
          </Navbar.Collapse>
        </Navbar>
      </div>
      { /* Desktop  */ }
      <div className={classnames(styles.root, styles.desktopHidden)}>
        <FloNavBar
          onLogout  = {() => props.onLogout(history)}
          user      = {props.user}
          isMobile  = {false}
        />
      </div>
    </>
  );
};

export default SideBar;
